import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogComponent } from 'src/app/views/share/dialog/dialog.component';
import { User } from 'src/models/user.model';
import { DialogService } from 'src/services/dialog.service';
import { UserService } from 'src/services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss'],
})
export class UserManagementComponent implements OnInit {
  tab: number = 0;
  userData: any;
  userId!: string;
  loading: boolean = false;
  type: string = '';
  title: string = '';

  campaigns: any = [];
  ecoupons: any = [];
  quests: any = [];
  assistants: any = [];
  assistantPaginationList: any = [];

  selectedAssistant: any = {
    campaign: '',
    quest: '',
    coupon: '',
  };

  paginationCampaign: any = {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
  };

  paginationQuest: any = {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
  };

  paginationCoupon: any = {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
  };

  paginationAssistant: any = {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
  };

  rewardList: any[] = [
    {
      id: 'POINT',
      name: 'Point',
    },
    {
      id: 'ECOUPON',
      name: 'E-Coupon',
    },
    {
      id: 'ECOUPON_AND_POINT',
      name: 'Point & E-Coupon',
    },
  ];

  constructor(
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.title = 'รายละเอียด PC';
    this.getUser();
    this.historyCampaign();
    this.historyQuest();
    this.historyECoupon();
    this.historyAssistant();
  }

  onPageChange(param: any, tableName: string) {
    if (tableName === 'campaign') {
      this.paginationCampaign.currentPage = param.currentPage;
      this.paginationCampaign.itemsPerPage = param.itemsPerPage;
      this.historyCampaign();
    }
    if (tableName === 'quest') {
      this.paginationQuest.currentPage = param.currentPage;
      this.paginationQuest.itemsPerPage = param.itemsPerPage;
      this.historyQuest();
    }
    if (tableName === 'coupon') {
      this.paginationCoupon.currentPage = param.currentPage;
      this.paginationCoupon.itemsPerPage = param.itemsPerPage;
      this.historyECoupon();
    }
    if (tableName === 'assistant') {
      this.paginationAssistant.currentPage = param.currentPage;
      this.paginationAssistant.itemsPerPage = param.itemsPerPage;
      this.historyAssistant();
    }
  }

  filterByAssistant(tableName: string) {
    if (tableName === 'campaign') {
      // filter
    }
    if (tableName === 'quest') {
      // filter
    }
    if (tableName === 'coupon') {
      // filter
    }
    if (tableName === 'assistant') {
      // filter
    }
  }

  async getUser() {
    var id = await JSON.parse(localStorage.getItem('user')!).id;
    this.userService.getProfilePc({ id: id }).subscribe({
      next: (res) => {
        this.userData = res;
        console.log(this.userData);
      },
      error: (error) => this.handleError('ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง'),
    });
  }

  displayRewardType(param: string): string {
    return this.rewardList.find((e) => e.id == param)?.name ?? '';
  }

  async historyCampaign() {
    var id = await JSON.parse(localStorage.getItem('user')!).id;
    const criteria: any = {
      page: this.paginationCampaign.currentPage,
      limit: this.paginationCampaign.itemsPerPage,
      searchCriteria: [
        {
          entity: 'pcScanner',
          field: 'id',
          value: id,
        },
      ],
      sortCriteria: [
        {
          entity: 'campaignHistory',
          field: 'startAt',
          order: 'desc',
        },
      ],
    };
    this.userService.historyCampaign(criteria).subscribe({
      next: (res) => {
        this.campaigns = res.items;
        this.paginationCampaign.totalItems = res.total;
      },
      error: (error) => this.handleError('ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง'),
    });
  }

  async historyQuest() {
    var id = await JSON.parse(localStorage.getItem('user')!).id;
    const criteria: any = {
      page: this.paginationQuest.currentPage,
      limit: this.paginationQuest.itemsPerPage,
      searchCriteria: [
        {
          entity: 'pcScanner',
          field: 'id',
          value: id,
        },
      ],
      sortCriteria: [
        {
          entity: 'questHistories',
          field: 'startAt',
          order: 'desc',
        },
      ],
    };
    this.userService.historyQuest(criteria).subscribe({
      next: (res) => {
        this.quests = res.items;
        this.paginationQuest.totalItems = res.total;
      },
      error: (error) => this.handleError('ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง'),
    });
  }

  async historyECoupon() {
    var id = await JSON.parse(localStorage.getItem('user')!).id;
    const criteria: any = {
      page: this.paginationCoupon.currentPage,
      limit: this.paginationCoupon.itemsPerPage,
      searchCriteria: [
        {
          entity: 'pcScanner',
          field: 'id',
          value: id,
        },
      ],
      sortCriteria: [
        {
          entity: 'eCouponHistories',
          field: 'receiveDate',
          order: 'desc',
        },
      ],
    };
    this.userService.historyECoupon(criteria).subscribe({
      next: (res) => {
        this.ecoupons = res.items;
        this.paginationCoupon.totalItems = res.total;
      },
      error: (error) => this.handleError('ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง'),
    });
  }

  async historyAssistant() {
    var id = await JSON.parse(localStorage.getItem('user')!).id;
    this.userService.historyAssistant({ pcId: id }).subscribe({
      next: (res) => {
        this.assistants = res;
        this.paginationAssistant.totalItems = this.assistants.length ?? 0;
        this.assistantPaginationList = this.paginatedAssistant;
      },
      error: (error) => this.handleError('ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง'),
    });
  }

  deleteData() {
    this.dialogService.openDialog(
      {
        action: 'delete',
        title: 'ลบข้อมูล',
        hasBtn: true,
        message: 'คุณแน่ใจหรือว่าต้องการลบ',
      },
      (action) => {
        if (action) {
          // this.userService
          // .deleteUser(this.userId)
          // .subscribe({
          //   next: (res) => {
          //     this.dialogService.openDialog({
          //       action: 'success',
          //       title: 'สำเร็จ',
          //       message: 'ลบ PC สำเร็จ',
          //     }, (action) => this.goBack());
          //   },
          //   error: (error) => {
          //     this.loading = false;
          //     this.dialogService.openDialog({
          //       action: 'fail',
          //       title: 'ไม่สามารถดำเนินการได้',
          //       message: 'ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง'
          //     }, (action) => null);
          //   },
          // });
        }
      }
    );
  }

  get paginatedAssistant(): any[] {
    const startIndex = (this.paginationAssistant.currentPage - 1) * this.paginationAssistant.itemsPerPage;
    return this.assistants.slice(startIndex, startIndex + this.paginationAssistant.itemsPerPage);
  }

  edit() {
    this.router.navigate(['/user-management/pc/edit/' + this.userId]);
  }

  goBack(): void {
    this.router.navigate(['/user-management/pc']);
  }

  private handleError(message: string) {
    this.loading = false;
    this.dialogService.openDialog(
      {
        action: 'fail',
        title: 'ไม่สามารถดำเนินการได้',
        message: message,
      },
      () => null
    );
  }

  openDialog(data: any, callback: (data: boolean) => void): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '520px',
      data,
    });
    dialogRef
      .afterClosed()
      .subscribe((result) => callback(result === 'confirm'));
  }
}
